import React from "react";
import SharedResultPage from "./SharedResultPage";

/**
 * Previous result page. Renders the shared result UI with stored/previous result data.
 */
export default function PreviousResult() {
  return <SharedResultPage isPreviousResult />;
}
